module.exports = __webpack_public_path__ + "static/media/logistics-promo.9cf5043e.jpg";